import { useMutation } from '@tanstack/react-query';
import { PermissionAssignmentsApi } from '@digiwedge/access-control-api-client';
import { createAccessControlConfiguration, createAccessControlQueryScope, useAccessControlContext, } from './AccessControlApiProvider.js';
export function usePermissionAssignmentsControllerCreateAssignmentMutation(options) {
    const accessControlContext = useAccessControlContext();
    const accessControlScope = createAccessControlQueryScope(accessControlContext);
    const accessControlConfig = createAccessControlConfiguration(accessControlContext);
    return useMutation({
        mutationKey: ['permissionAssignmentsControllerCreateAssignment', accessControlScope],
        mutationFn: async (args) => {
            const api = new PermissionAssignmentsApi(accessControlConfig);
            return api.permissionAssignmentsControllerCreateAssignment(...args);
        },
        ...options,
    });
}
//# sourceMappingURL=usePermissionAssignmentsControllerCreateAssignmentMutation.js.map